<template>
    <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="loadList">
        <slot :list="list"></slot>
    </van-list>
</template>

<script>
import { List } from "vant";
import $http from "@/utils/request";
export default {
    props: {
        api: {
            type: Function,
            required: true,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        params: {
            type: Object,
            defautl: () => new Object(),
        },
        filter: {
            type: Function,
            default: list => list,
        },
    },
    watch: {
        params: {
            handler(newV) {
                this.params_com = newV;
            },
            deep: true,
        },
    },
    components: {
        [List.name]: List,
    },
    data() {
        return {
            finishedText: "暂无内容~",
            page: 0,
            loading: false,
            finished: false,
            list: [],
            params_com: {},
        };
    },
    created() {
        this.params_com = this.params;
    },
    methods: {
        initList() {
            this.page = 0;
            this.list = [];
            this.loadList();
        },
        loadList() {
            this.page++;
            this.getList();
        },
        getList() {
            let fixedParams = { pageSize: this.pageSize, page: this.page };
            this.api({ ...fixedParams, ...this.params_com })
                .then(res => {
                    if (res.code == 200) {
                        if (!res.data.records || !res.data.total) {
                            this.loading = false;
                            this.finished = true;
                            this.finishedText = "暂无内容~";
                        }
                        //单次加载完成
                        this.loading = false;
                        //如果有数据则push
                        if (res.data.records && res.data.records.length > 0) {
                            this.list = this.list.concat(this.filter(res.data.records));
                        }
                        //如果当前页数为最大页数（总条数除以每页条数，向上取整）
                        if (this.page >= Math.ceil(res.data.total / this.pageSize)) {
                            //结束所有加载
                            this.finished = true;
                            this.finishedText = "没有更多了~";
                        }
                        //如果总条数为0
                        if (res.data.total == 0) {
                            //结束所有加载
                            this.finished = true;
                            this.finishedText = "暂无内容~";
                        }
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.finishedText = "加载失败";
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.finished = true;
                    this.finishedText = "加载失败";
                });
        },
    },
};
</script>
